<template>
  <div>
    <Navigation />
    <section class="top__container section__container">
      <h1 class="marche__header center__text">
        Suivez le guide, et réalisez vos campagnes SMS en seulement 4 étapes
      </h1>
      <div class="grid__normal seventy__container ">
        <div class="marche__text">
          <h2>Étape 1 : Créez votre compte</h2>
          <p>
            Complétez le formulaire d'inscription en fournissant votre adresse e-mail et votre numéro de téléphone. <br/>Votre compte sera créé sans aucun engagement.
          </p>
      
          <p class="last__paragraph">
            Clause de confidentialité : Soyez assuré(e) que SERVICES-SMS s'engage
            à ne jamais exploiter vos informations personnelles à des fins de marketing
            ni à les divulguer à des tiers.
          </p>
          
        </div>
        <img
          class="marche__image img__responsive"
          src="/../images/marche/mail_num_1.png"
          alt=""
        />
      </div>

      <div class="grid__normal seventy__container">
        <img
          class="marche__image img__responsive"
          src="/../images/marche/contact_imp_2.png"
          alt=""
        />
        <div class="marche__text">
          <h2>Étape 2 : Importez facilement votre liste de contacts SMS</h2>
          <p>
            Intégrez rapidement vos listes de contacts,
            gérez facilement les listes noires, les champs de publipostage
            et les filtres de segmentation.
          </p>

          <p class="last__paragraph">
            Profitez également de fonctions de recherche avancées et de puissantes fonctionnalités d'import/export.
            Les doublons et les numéros erronés sont automatiquement supprimés.
          </p>
        </div>
      </div>

      <div class="grid__normal seventy__container ">
        <div class="marche__text">
          <h2>Étape 3 : Lancez votre campagne SMS dès maintenant</h2>
          <p>
            Rédigez votre message sur une interface conviviale et intuitive.
            Personnalisez l'émetteur, choisissez entre un envoi immédiat ou programmé,
            et utilisez des modèles réutilisables avec des champs de publipostage pour
            personnaliser vos envois.
            </p>
            <p class="last__paragraph">
              "Bonjour M. #NOM#, nous vous invitons à notre journée d'intégration qui 
              se tiendra le samedi 28 janvier 2023.". Testez et envoyez votre message.
          </p>
        </div>
        <img
          class="marche__image img__responsive"
          src="/../images/marche/camp_lancer_3.png"
          alt=""
        />
      </div>

      <div class="grid__normal seventy__container">
        <img
          class="marche__image img__responsive"
          src="/../images/marche/accusé_recept_4.png"
          alt=""
        />
        <div class="marche__text">
          <h2>Étape 4 : Consultez les statistiques de vos campagnes en toute simplicité</h2>
          <p>
            Obtenez des rapports statistiques précis sur vos campagnes, y compris 
            les volumes de SMS envoyés en temps réel, grâce à des fonctionnalités de filtrage avancées.
            </p>
            <p class="last__paragraph">
              Dans votre espace client, vous trouverez également des informations détaillées, 
              par numéro, sur la délivrabilité de vos SMS.
          </p>
        </div>
      </div>
    </section>
    <Footer/>
  </div>
</template>

<script>
import Navigation from "./Navigation";
import Footer from "./Footer";
export default {
  components: {
    Navigation,
    Footer
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";

.marche__header {
  color: $color-tertiary;
  background: $color-grey;
}
.marche__text {
  box-shadow: 0 20px 40px -14px rgba(0, 0, 0, 0.25);
  padding: 2rem;
  margin-bottom:1rem;
}

.last__paragraph {
  border-left: 3px solid $color-tertiary;
  padding-left: 1rem;
  
}
@media (min-width: 64rem) {
  .top__container{
  margin-top:9rem;
 }
  .marche__header {
    padding: 2rem;
  }
  .grid__normal {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0;
  }
}
</style>
